import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "fixed top-0 right-0 bg-white z-50 py-2 px-4 shadow-sm border-b border-l border-gray-200 rounded-bl-2xl"
}
const _hoisted_2 = {
  href: "#",
  class: "flex-shrink-0 block"
}
const _hoisted_3 = { class: "flex items-center" }
const _hoisted_4 = { class: "ml-3" }
const _hoisted_5 = { class: "text-sm font-medium text-gray-700" }

import { injectStrict } from '@/plugins/vueServiceContainerPlugin';
import { Account, AuthenticationServiceInterface } from '@/services/authentication/authenticationServiceInterface';
import store from '@/store';
import { computed } from 'vue';


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const authenticationService = injectStrict<AuthenticationServiceInterface>('AuthenticationServiceInterface');

const account = computed<Account | null>(() => {
  return store.state.account;
});

const logout = () => {
  authenticationService.doLogout();
};

return (_ctx: any,_cache: any) => {
  return (_unref(account) !== null)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("p", _hoisted_5, _toDisplayString(_unref(account).name) + " <" + _toDisplayString(_unref(account).email.toLowerCase()) + "> ", 1),
              _createElementVNode("p", {
                onClick: logout,
                class: "text-right text-xs font-medium text-gray-500 hover:text-gray-700 cursor-pointer"
              }, " Log out ")
            ])
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})